import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, OnInit } from '@angular/core';
import { ActionSheetController, Platform } from 'ionic-angular';
import { File } from '@ionic-native/file';
import { UserService } from '../../../../user/user.service';
import { FileUploader } from 'ng2-file-upload';
import { KeystoneHttpClient } from '../../../../../keystone-http';
import { Observable } from 'rxjs';

/**
   * Logger Factory
   * @namespace image: is the image to show
   * @namespace isEditable: if is true the image is editable
   * @namespace shadow: if is false the shadow is removed
   * <ute-avatar class="image"  image="..." isEditable="true"></ute-avatar>
*/

@Component({
  selector: 'ute-avatar',
  templateUrl: 'ute-avatar.component.html'
})
export class UteAvatarComponent implements OnChanges, OnInit {
  @Input() image: string;
  @Input() isEditable: boolean = false;
  @Input() shadow: boolean = true;
  @Output() onClickAction = new EventEmitter;

  public img: any; 
  public editable: any;
  public imageUrl: any;
  public uploader: FileUploader;

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public platform: Platform, 
    public file: File,
    private authHttp: KeystoneHttpClient,
    public userService: UserService
    ) {}

  ngOnInit(){
    this.uploadFile();
    if(this.image){
      this.img = this.image;
    }else{
      this.img = this.image || 'assets/imgs/camera-blue.png';
    }
    if(this.isEditable){
      this.img = this.image || 'assets/imgs/camera.png';
    }
  }


  uploadFile(){
    this.authHttp.retrieveHeaders()
      .catch((error) => {
          console.error(error);
          return Observable.of(error);
      }).subscribe(async ([token, uid]) => {
        this.uploader = new FileUploader({
          url: `${this.authHttp.baseUrl}/upload-avatar/${this.userService.getCurrentUser()._id}`,
          itemAlias: 'avatar',
          autoUpload: true,
          headers: [
            {name : 'Token', value: token},
            {name : 'Uid', value: uid},
            {name : 'Enctype', value: `multipart/form-data`}
          ]
        })
        this.uploader.onAfterAddingFile = (file) => {
          file.withCredentials = false;
        };
        this.uploader.onCancelItem = (file, response) => {}
      });
  }

  onClickCamera(event){
    this.onClickAction.emit(event);
  }

  onChange() {}

  importFile(event) {
    if (event.target.files.length == 0) { return; }
    let file: File = event.target.files[0];
    this.onClickAction.emit(file);
  }

  selectFile(){}

  onClickUpload(event){
    this.onClickAction.emit(event);
  }

  ngOnChanges(simpleChange: SimpleChanges){
    this.img = simpleChange.image.currentValue;
  }
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-avatar/ute-avatar.component.ts